var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_14589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99989 3.5008C5.31255 3.45547 2.53322 5.33347 0.785885 7.2568C0.602474 7.46043 0.500977 7.72476 0.500977 7.9988C0.500977 8.27285 0.602474 8.53718 0.785885 8.7408C2.49522 10.6235 5.26655 12.5448 7.99989 12.4988C10.7332 12.5448 13.5052 10.6235 15.2159 8.7408C15.3993 8.53718 15.5008 8.27285 15.5008 7.9988C15.5008 7.72476 15.3993 7.46043 15.2159 7.2568C13.4666 5.33347 10.6872 3.45547 7.99989 3.5008Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.00067C10.4999 8.49509 10.3531 8.97838 10.0784 9.38941C9.80357 9.80045 9.41307 10.1208 8.95625 10.3099C8.49942 10.499 7.99678 10.5484 7.51187 10.4519C7.02696 10.3553 6.58156 10.1172 6.232 9.76753C5.88243 9.41787 5.6444 8.97242 5.54799 8.48748C5.45158 8.00255 5.50113 7.49991 5.69037 7.04314C5.8796 6.58636 6.20004 6.19595 6.61114 5.92128C7.02225 5.64661 7.50558 5.5 8 5.5C8.32839 5.49991 8.65357 5.56454 8.95697 5.69019C9.26036 5.81583 9.53603 6.00004 9.7682 6.23227C10.0004 6.46451 10.1845 6.74022 10.3101 7.04365C10.4356 7.34708 10.5002 7.67228 10.5 8.00067Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_14589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7cdaef50d81cce463ff841f3976906f7.svg";
export { ForwardRef as ReactComponent };